// ABOUTME: Custom cart-drawer behavior for AquaTru — Search & Discovery complementary upsell.
// ABOUTME: Layers non-native logic on top of Dawn's <cart-drawer> web component / Section Rendering API.
(function () {
  'use strict';

  var UPSELL_COUNT = 3;

  // What Yotpo resolved each product's star widget to, keyed by product id: the
  // rendered star HTML, or '' when the product has no reviews. Lets a cart
  // re-render restore stars synchronously instead of blinking them out (CLS).
  var ratingCache = {};
  // Last rendered filled-cart upsell cards, carried into a freshly re-rendered
  // (blank) wrapper so the strip keeps its height instead of collapsing (CLS).
  var lastUpsellListHTML = '';

  function routes() {
    return window.routes || {};
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    // Match the Liquid cart-money pattern: drop the decimals when the price is round.
    var fractionDigits = cents % 100 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(fractionDigits);
    }
  }

  // ---- Upsell ---------------------------------------------------------------

  // The partner-sale product must never be recommended. Match on handle / url /
  // title / type so it's excluded from both the dynamic recommendations and the
  // empty-cart collection list.
  function isPartnerSale(product) {
    var hay = (
      (product.handle || '') +
      ' ' +
      (product.url || '') +
      ' ' +
      (product.title || '') +
      ' ' +
      (product.type || '')
    ).toLowerCase();
    return /partner[\s_-]?sale/.test(hay);
  }

  function normalize(product) {
    var variant = product.variant;
    if (!variant && product.variants && product.variants.length) {
      var available = product.variants.find(function (v) {
        return v.available;
      });
      variant = (available || product.variants[0]).id;
    }
    return {
      id: product.id,
      title: product.title,
      url: product.url,
      price: product.price,
      image: product.image || product.featured_image || (product.images && product.images[0]) || '',
      variant: variant,
    };
  }

  function addToCartLabel() {
    return (window.cartUpsellStrings && window.cartUpsellStrings.addToCart) || 'Add to cart';
  }

  function cardHTML(p) {
    return (
      '<div class="atc__up-card">' +
      '<a class="atc__up-media" href="' + p.url + '" tabindex="-1">' +
      (p.image ? '<img src="' + p.image + '" alt="" width="72" height="72" loading="lazy">' : '') +
      '</a>' +
      '<div class="atc__up-info">' +
      '<a class="atc__up-title" href="' + p.url + '">' + p.title + '</a>' +
      '<div class="atc__up-rating yotpo bottomLine" data-product-id="' + p.id + '"></div>' +
      '<span class="atc__up-price">' + formatMoney(p.price) + '</span>' +
      '</div>' +
      '<button class="atc__up-add" type="button" data-upsell-add data-variant-id="' + p.variant + '" aria-label="' + addToCartLabel() + '">' +
      '<svg class="atc__up-add-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      '<span class="atc__up-add-label">' + addToCartLabel() + '</span>' +
      '</button>' +
      '</div>'
    );
  }

  function fetchRecommendations(productIds, intent) {
    var seen = {};
    productIds.forEach(function (id) {
      seen[id] = true;
    });

    var url = (routes().product_recommendations_url || '/recommendations/products') + '.json';

    // Fetch recommendations for every cart product in PARALLEL (the old code chained
    // them one after another), then merge in cart order. Wall-clock drops from the
    // sum of the requests to the slowest single request.
    var requests = productIds.map(function (id) {
      return fetch(url + '?product_id=' + id + '&limit=10&intent=' + intent)
        .then(function (r) {
          return r.ok ? r.json() : { products: [] };
        })
        .catch(function () {
          return { products: [] };
        });
    });

    return Promise.all(requests).then(function (results) {
      var collected = [];
      results.forEach(function (data) {
        (data.products || []).forEach(function (p) {
          if (!seen[p.id] && !isPartnerSale(p) && collected.length < UPSELL_COUNT) {
            seen[p.id] = true;
            collected.push(normalize(p));
          }
        });
      });
      return collected.slice(0, UPSELL_COUNT);
    });
  }

  // Curated complementary products first; fall back to related when none are
  // configured in Search & Discovery so the upsell never renders empty.
  function fetchUpsellProducts(productIds) {
    return fetchRecommendations(productIds, 'complementary').then(function (list) {
      return list.length ? list : fetchRecommendations(productIds, 'related');
    });
  }

  function renderCards(products, listEl, wrapEl) {
    if (!products || !products.length) {
      wrapEl.hidden = true;
    } else {
      listEl.innerHTML = products.map(cardHTML).join('');
      wrapEl.hidden = false;
      // Remember the filled-cart cards so the next re-render can show them
      // immediately (see primeUpsell) instead of collapsing to a blank strip.
      if (wrapEl.hasAttribute('data-cart-products')) {
        lastUpsellListHTML = listEl.innerHTML;
      }
    }
    // Single re-init point for the drawer's Yotpo widgets (line items + upsell),
    // reached after the upsell finishes rendering. ensureYotpo() is debounced.
    ensureYotpo();
  }

  // Fixed-height placeholder cards shown while real recommendations load, so the
  // upsell strip reserves its final height up front (no first-load CLS). Same
  // dimensions as a real card — the 72px media box governs the height either way.
  function skeletonHTML() {
    var card =
      '<div class="atc__up-card atc__up-card--skeleton" aria-hidden="true">' +
      '<span class="atc__up-media"></span>' +
      '<div class="atc__up-info">' +
      '<span class="atc__up-skel-line atc__up-skel-line--lg"></span>' +
      '<span class="atc__up-skel-line atc__up-skel-line--sm"></span>' +
      '</div>' +
      '</div>';
    var out = '';
    for (var i = 0; i < UPSELL_COUNT; i++) out += card;
    return out;
  }

  // Reserve the upsell strip's height the instant it re-renders (blank, hidden) so
  // it never collapses while fresh recommendations are fetched: carry the previous
  // cards over if we have them, otherwise drop in a fixed-height skeleton. Either
  // way the strip keeps a constant height, so the real cards swap in with no CLS.
  // Filled-cart variant only — the empty-cart upsell is a different product set.
  function primeUpsell(wrap) {
    if (!wrap || !wrap.hasAttribute('data-cart-products')) return;
    var list = wrap.querySelector('[data-upsell-list]');
    if (!list || list.innerHTML.trim()) return; // already filled this render
    list.innerHTML = lastUpsellListHTML || skeletonHTML();
    wrap.hidden = false;
    applyRatingCache();
  }

  function initUpsell() {
    var wrap = document.querySelector('[data-cart-upsell]');
    if (!wrap) return;
    var list = wrap.querySelector('[data-upsell-list]');
    if (!list) return;

    var emptyEl = wrap.querySelector('[data-upsell-empty]');
    if (emptyEl) {
      var products = [];
      try {
        products = JSON.parse(emptyEl.textContent)
          .filter(function (p) {
            return !isPartnerSale(p);
          })
          .map(normalize);
      } catch (e) {
        products = [];
      }
      renderCards(products, list, wrap);
      return;
    }

    var cartData = wrap.getAttribute('data-cart-products');
    if (!cartData) {
      wrap.hidden = true;
      return;
    }
    var ids;
    try {
      ids = JSON.parse(cartData);
    } catch (e) {
      ids = [];
    }
    if (!ids.length) {
      wrap.hidden = true;
      return;
    }
    if (!list.innerHTML.trim()) {
      // No carried-over cards yet (first open / first add) — reserve the height
      // with a skeleton so the recommendations don't pop in and shift the layout.
      list.innerHTML = skeletonHTML();
      wrap.hidden = false;
    }
    fetchUpsellProducts(ids).then(function (products) {
      renderCards(products, list, wrap);
    });
  }

  // ---- Add to cart from an upsell card --------------------------------------

  function addVariant(variantId, button) {
    if (!variantId) return;
    button.classList.add('is-loading');
    maskCart(); // cover the cart while it re-renders + Yotpo settles
    fetch((routes().cart_add_url || '/cart/add'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (state) {
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && state.sections) {
          cartDrawer.renderContents(state);
        }
        // renderContents replaces the drawer DOM; re-run upsell against fresh data.
        // initUpsell() chains into renderCards() -> ensureYotpo() for the reviews.
        initUpsell();
      })
      .catch(function () {
        button.classList.remove('is-loading');
      });
  }

  // ---- Yotpo review widgets -------------------------------------------------
  // Yotpo's loader scans the DOM on page load, but the cart-drawer is hidden
  // until opened and its line items are re-rendered via the Section Rendering
  // API, so the star-rating widgets must be (re)initialised on open and after
  // every cart change. Supports both the classic loader (window.yotpo) and the
  // newer widget container (window.yotpoWidgetsContainer).

  function refreshYotpo() {
    var refreshed = false;
    // New Yotpo loader (cdn-widgetsrepository) — the widget container.
    try {
      var c = window.yotpoWidgetsContainer;
      if (c && typeof c.initWidgets === 'function') {
        c.initWidgets();
        refreshed = true;
      }
    } catch (e) {}
    // Classic Yotpo loader (staticw2) — global yotpo API.
    try {
      var y = window.yotpo;
      if (y && typeof y.refreshWidgets === 'function') {
        y.refreshWidgets();
        refreshed = true;
      } else if (y && typeof y.initWidgets === 'function') {
        y.initWidgets();
        refreshed = true;
      }
    } catch (e) {}
    return refreshed;
  }

  // A single cart change re-renders the drawer several times (line items + upsell
  // cards settle at different moments), and initWidgets() re-renders EVERY Yotpo
  // widget on the page — so calling it per change made already-rendered ratings
  // blink (appear → vanish → reappear) and shifted the layout. Instead, restore
  // each product's stars synchronously from the cache on every re-render, and only
  // (re)invoke Yotpo when some widget has never resolved — so quantity changes,
  // which add no new product, never re-init Yotpo.
  function ratingNodes() {
    return document.querySelectorAll(
      '.atc__item-rating[data-product-id], .atc__up-rating[data-product-id]'
    );
  }

  // Fill freshly re-rendered (empty) rating slots from what Yotpo already
  // resolved. Returns true when a slot has no cached result yet (needs Yotpo).
  function applyRatingCache() {
    var nodes = ratingNodes();
    var pending = false;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.innerHTML.trim()) continue; // already filled this render
      var id = el.getAttribute('data-product-id');
      var cached = id ? ratingCache[id] : undefined;
      if (cached === undefined) {
        pending = true; // never resolved — let Yotpo render it
      } else if (cached === '') {
        // No reviews — keep the reserved box but hide it (visibility, not display)
        // so the rating row never collapses and shifts the layout. Stars or not,
        // every line item and upsell card keeps a constant height.
        el.style.visibility = 'hidden';
      } else {
        el.innerHTML = cached; // resolved with stars — restore instantly
      }
    }
    return pending;
  }

  // Record what Yotpo resolved each widget to (star HTML, or '' for no reviews)
  // and collapse the empty ones. Yotpo renders asynchronously, so this runs on a
  // few delays after an init.
  function captureRatings() {
    var nodes = ratingNodes();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var id = el.getAttribute('data-product-id');
      if (!id) continue;
      var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!txt) continue; // not rendered yet — leave it for the next pass
      if (/\b0\s*(reviews?|ratings?)\b/i.test(txt) || /\(0\)/.test(txt) || /no reviews/i.test(txt)) {
        ratingCache[id] = '';
        el.style.visibility = 'hidden'; // keep the reserved box (no collapse, no shift)
      } else {
        ratingCache[id] = el.innerHTML;
      }
    }
  }

  // Full-cart loader. On a cart change Yotpo's global init re-renders every rating
  // on the page (it can't be scoped to one widget) and keeps painting stars async
  // for seconds, so any per-widget reveal is raced. Instead mask the WHOLE inner
  // panel: it goes visibility:hidden (the churn + star blink is neither visible nor
  // counted as layout shift) with a spinner on top, revealed once things settle.
  // The .atc__loader markup lives in cart-drawer.liquid so it survives every render.
  var cartLoadingTimer;
  function setCartLoading(on) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('atc--loading', on);
  }

  // Reveal the settled cart: drop the mask and, if an add deferred the drawer's
  // open (so it pops open already-loaded instead of onto a spinner), open it now.
  function finishCartLoading() {
    applyRatingCache();
    setCartLoading(false);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.__atcWantOpen) {
      drawer.__atcWantOpen = false;
      drawer.open();
    }
  }

  function maskCart() {
    setCartLoading(true);
    clearTimeout(cartLoadingTimer);
    cartLoadingTimer = setTimeout(finishCartLoading, 2500); // failsafe — never stick
  }

  function revealCartAfter(ms) {
    clearTimeout(cartLoadingTimer);
    cartLoadingTimer = setTimeout(finishCartLoading, ms);
  }

  // Every rating slot has either rendered (non-empty) or resolved to no-reviews
  // (visibility:hidden) — i.e. nothing is mid-blink, safe to reveal.
  function ratingsSettled() {
    var nodes = ratingNodes();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.style.visibility === 'hidden') continue;
      if (!el.innerHTML.trim()) return false;
    }
    return true;
  }

  // Reveal as soon as the ratings have actually painted (not after a fixed wait),
  // so the drawer opens the instant it's ready. Capped so it never hangs.
  function revealWhenSettled() {
    var attempts = 0;
    (function poll() {
      if (ratingsSettled()) {
        revealCartAfter(120); // brief grace to avoid catching a transient frame
        return;
      }
      if (attempts >= 18) {
        finishCartLoading(); // ~1.4s cap — reveal anyway
        return;
      }
      attempts += 1;
      setTimeout(poll, 80);
    })();
  }

  var yotpoTimer;
  function ensureYotpo() {
    var pending = applyRatingCache(); // restore known stars immediately
    clearTimeout(yotpoTimer);
    if (!pending) {
      revealCartAfter(120); // nothing for Yotpo to render — drop the mask quickly
      return;
    }
    maskCart(); // Yotpo's global init is about to blink every rating — mask first
    yotpoTimer = setTimeout(function () {
      runYotpoInit(0);
    }, 120);
  }

  // Yotpo's loader may not be ready when the drawer first opens — retry briefly.
  function runYotpoInit(attempt) {
    if (refreshYotpo()) {
      scheduleRatingCleanup();
      revealWhenSettled(); // reveal/open the moment the stars are painted
      return;
    }
    if (attempt >= 10) {
      finishCartLoading();
      return;
    }
    setTimeout(function () {
      runYotpoInit(attempt + 1);
    }, 200);
  }

  function scheduleRatingCleanup() {
    [1200, 2500, 4000].forEach(function (delay) {
      setTimeout(captureRatings, delay);
    });
  }

  // Re-init the Yotpo review widgets when the drawer is opened without a cart
  // change (e.g. reopened) — they only auto-init on first page load.
  function watchDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof MutationObserver !== 'function') return;
    var wasActive = drawer.classList.contains('active');
    var observer = new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) ensureYotpo();
      wasActive = isActive;
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Rebuild the upsell + reviews whenever Dawn re-renders the drawer contents.
  // A cart change replaces the [data-cart-upsell] wrapper via TWO paths that land
  // at different times — CartDrawer.renderContents() (sync) and
  // CartDrawerItems.onCartUpdate()'s async fetch + replaceWith — so reacting to the
  // cartUpdate event fills a node that is about to be discarded, and the cards
  // vanish (only a full reload fixes it). Instead, watch for a NEW wrapper node and
  // fill that one. Keyed on node identity so each render is filled exactly once and
  // our own fill (which mutates the list) never retriggers the observer.
  function watchCartRender() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof MutationObserver !== 'function') return;
    var lastWrap = document.querySelector('[data-cart-upsell]');
    var settle;
    new MutationObserver(function () {
      // On a NEW cart render, mask the ratings BEFORE touching anything (so the
      // re-injected/blinking stars are never seen), then rehydrate stars and carry
      // the previous upsell cards into the freshly rendered (blank) nodes so nothing
      // collapses between Dawn's render bursts (renderContents + onCartUpdate).
      var wrapNow = document.querySelector('[data-cart-upsell]');
      var isNewRender = wrapNow && wrapNow !== lastWrap;
      if (isNewRender) maskCart();
      applyRatingCache();
      if (isNewRender) primeUpsell(wrapNow);

      // Then wait for the bursts to settle and fill the FINAL wrapper once with
      // fresh recommendations. initUpsell() chains into renderCards() ->
      // ensureYotpo(), so the reviews resolve once too.
      clearTimeout(settle);
      settle = setTimeout(function () {
        var wrap = document.querySelector('[data-cart-upsell]');
        if (wrap && wrap !== lastWrap) {
          lastWrap = wrap;
          initUpsell();
        }
      }, 250);
    }).observe(drawer, { childList: true, subtree: true });
  }

  // ---- Disable Rebuy Smart Cart ---------------------------------------------
  // Rebuy's Smart Cart loads via an app ScriptTag (cdn.rebuyengine.com/.../rebuy.js
  // ?shop=...), NOT the theme app embed — so toggling the embed off does not stop
  // it, and it renders #rebuy-cart on top of our drawer. Overriding shouldRender +
  // destroy() removes it and keeps it from re-rendering on add-to-cart (verified
  // against the live Rebuy build). This file only loads when settings.cart_type is
  // 'drawer', so the kill is scoped to where our drawer is the active cart.
  function killRebuySmartCart() {
    if (!(window.Rebuy && window.Rebuy.SmartCart)) return false;
    window.Rebuy.SmartCart.shouldRender = function () {
      return false;
    };
    try {
      window.Rebuy.SmartCart.destroy();
    } catch (e) {}
    return true;
  }

  function disableRebuy() {
    // Rebuy loads async, so poll until Smart Cart exists, then disable it.
    var tries = 0;
    var timer = setInterval(function () {
      if (killRebuySmartCart() || (tries += 1) > 100) clearInterval(timer);
    }, 50);
    // If Rebuy ever re-inserts its cart, tear it down again.
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        if (document.getElementById('rebuy-cart')) killRebuySmartCart();
      }).observe(document.body, { childList: true });
    }
  }

  // ---- Wiring ---------------------------------------------------------------

  document.addEventListener('click', function (event) {
    var addBtn = event.target.closest('[data-upsell-add]');
    if (addBtn) {
      event.preventDefault();
      addVariant(addBtn.getAttribute('data-variant-id'), addBtn);
      return;
    }
    // Mask the cart the instant a quantity +/- is pressed — before Dawn even
    // fetches — so there's no gap between the click and the loader. maskCart's
    // failsafe reveals it if (rarely) the press doesn't trigger a re-render.
    if (event.target.closest('.atc__qty-btn')) {
      maskCart();
    }
  });

  // Defer the drawer's auto-open on add-to-cart until the cart has settled, so it
  // pops open already-loaded instead of opening onto a spinner. Patches Dawn's
  // CartDrawer: renderContents (the add path) flags a wanted-open and starts the
  // loader; open() honours the flag; finishCartLoading() performs the real open.
  function patchCartDrawer() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('cart-drawer').then(function () {
      var ctor = customElements.get('cart-drawer');
      if (!ctor || ctor.prototype.__atcPatched) return;
      ctor.prototype.__atcPatched = true;
      var proto = ctor.prototype;
      var origRender = proto.renderContents;
      var origOpen = proto.open;

      proto.renderContents = function (parsedState) {
        if (!this.classList.contains('active')) {
          this.__atcWantOpen = true; // adding while closed — hold the open until settled
          maskCart(); // start the loader/settle clock before the open is scheduled
        }
        return origRender.call(this, parsedState);
      };

      proto.open = function (triggeredBy) {
        // A manual open (cart icon → triggeredBy) is always immediate; only the
        // add-to-cart auto-open is deferred while __atcWantOpen is set.
        if (this.__atcWantOpen && !triggeredBy) return;
        return origOpen.call(this, triggeredBy);
      };
    });
  }

  function init() {
    patchCartDrawer();
    disableRebuy();
    initUpsell();
    watchCartRender();
    watchDrawerOpen();
    ensureYotpo();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
